import Exams from './Exams';export default Exams;